module.exports = "/_next/static/images/7e1303b8e504dc48367196c194cb7426-notaxes@2x.jpg.webp";